import React from "react";
import { StyledContainer, StyledTitle, StyledChecklist, StyledButton, StyledDoneButton, StyledInnerText } from "./setup.style";
import ListItem from "./ListItem";
import { ReactComponent as SetupAccount } from "./img/SetupAccount.svg";

const SetupChecklist = ({ title, innerText, list, onDone, doneButtonDisabled, doneButtonLabel }) => {
	const renderList = () => {
		return list.map((item, index) => {
			const { label, getButtonLabel, onClick, getIsChecked, getIsDisabled } = item;
			return (
				<li key={index}>
					<ListItem label={label} checked={getIsChecked()} />
					<StyledButton type="button" checked={getIsChecked()} disabled={getIsDisabled()} onClick={onClick} value={item.buttonValue}>
						{getButtonLabel()}
					</StyledButton>
				</li>
			);
		});
	};
	return (
		<StyledContainer>
			<SetupAccount />
			<StyledTitle>{title}</StyledTitle>
			<StyledInnerText>{innerText}</StyledInnerText>
			<StyledChecklist>{renderList()}</StyledChecklist>
			<StyledDoneButton type="button" onClick={onDone} value="done" disabled={doneButtonDisabled}>
				{doneButtonLabel ? doneButtonLabel : "Done"}
			</StyledDoneButton>
		</StyledContainer>
	);
};
export default SetupChecklist;
